import { useCallback, useEffect, useState } from "react";
import { SimpleHttp } from "src/lib/utils/SimpleHTTP";


export default function useGetTools(selectedSpecialties) {
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [retryCount, setRetry] = useState(0);

  const retry = () => {
    setRetry((prev) => ++prev);
  };

  const fetchData = useCallback(async () => {
    const undefineds = [
      "undefined",
      "undefined",
      "undefined",
      "undefined",
      "undefined",
      "undefined",
      "undefined",
      "undefined",
    ];

    try {
      const transformed = undefineds
        .map((value, index) => {
          return selectedSpecialties[index]?.id ?? value;
        })
        .toString()
        .replaceAll(",", "/");

      const url = `/api/v1/comp/getFrameworksBasedOnLanguages/${transformed}`;

      const { status, message, data } = await SimpleHttp.getNoAuth(url);

      if (status === true) {
        setTools(data);
      } else {
        setError(message);
      }
    } catch (error) {
      console.log("Tools Error:", error);
      setError(error);
    }

    setLoading(false);
  }, [selectedSpecialties]);


  useEffect(() => {
    setError(undefined);
    setLoading(true);
    fetchData();
  }, [selectedSpecialties, retryCount]);

  return { tools, loading, error, retry };
}
